import { c, b } from './chunk-JM7L7N4B.mjs';
import { d } from './chunk-P3JYYZWU.mjs';
import { a } from './chunk-QWEGO2DW.mjs';
import { a as a$1 } from './chunk-BYJTSHAJ.mjs';
import t from 'react';
import { Loading, LoadingOverlay, SentryLogo, Toggle } from '@crossbell/ui';
import { useConnect } from 'wagmi';
import { useAccountCharacter, useCharacterAttribute } from '@crossbell/react-account';

var f="b55c833c446df7998c394ba28aed70b91d25e5ea7e368533811345d8eef963a0",y=`._placeholder_9tq78_1 {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 2em;
	color: rgba(var(--csb-ck-color-text), 0.5);
	height: 30vh;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(f)){var e=document.createElement("style");e.id=f,e.textContent=y,document.head.appendChild(e);}})();var u={placeholder:"_placeholder_9tq78_1"};function g(e){return function(c){return t.createElement(t.Suspense,{fallback:t.createElement(x,null)},t.createElement(e,{...c}))}}function x(){return t.createElement(a,null,t.createElement("div",{className:u.placeholder},t.createElement(Loading,null)))}var _="2d3b887c5dc91b592afd5c971ca8e354d51c3b5db56adea1f4d3ad03d020635f",h=`._tips_1fo93_1 {
	font-weight: 400;
	font-size: 14px;
	color: rgb(var(--csb-ck-color-text-subtle));
	text-align: center;
	margin-bottom: 20px;
	white-space: pre-wrap;
}

._tips_1fo93_1 svg {
	display: inline-block;
	font-size: 24px;
	vertical-align: bottom;
}

._item_1fo93_16 {
	display: flex;
	align-items: center;
	gap: 8px;
	background: rgb(var(--csb-ck-color-bg1));
	padding: 20px;
	border-radius: 12px;
	font-size: 16px;
	font-weight: 500;
	margin-bottom: 24px;
}

._item_1fo93_16 svg {
	font-size: 24px;
}

._toggle_1fo93_32 {
	margin-left: auto;
}

._mainBtn_1fo93_36 {
	height: 64px;
	background-color: rgb(var(--csb-ck-color-bg1));
	color: rgb(var(--csb-ck-color-text));
	margin-top: 12px;
	font-size: 16px;
	font-weight: 500;
}

._link_1fo93_45 {
	color: rgb(var(--color-246_197_73));
}

._link_1fo93_45:hover {
	text-decoration: underline;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(_)){var e=document.createElement("style");e.id=_,e.textContent=h,document.head.appendChild(e);}})();var r={tips:"_tips_1fo93_1",item:"_item_1fo93_16",toggle:"_toggle_1fo93_32",mainBtn:"_mainBtn_1fo93_36",link:"_link_1fo93_45"};function G(){let e=c(),n=D();return t.createElement(a,{padding:"10px 24px 36px",header:t.createElement(d,{title:"Privacy & Security"})},t.createElement(LoadingOverlay,{visible:e.isLoading}),t.createElement("div",{className:r.tips},"Apps that have asked for permission to track your activity with an identifier will appear here."),t.createElement("div",{className:r.item},t.createElement(SentryLogo,null),"Sentry",t.createElement(Toggle,{isActive:e.isEnabled,onToggle:e.toggle,className:r.toggle})),t.createElement(a$1,{color:"rgb(var(--color-106_217_145))"},`${n} use `,t.createElement("a",{className:r.link,href:"https://sentry.io/legal/dpa/",target:"_blank"},"Sentry [Data Processing Addendum]")," to collect necessary information to improve your experience."))}function J(){let{sentry:e}=b(),n=useAccountCharacter(),{data:c}=useCharacterAttribute({characterId:n?.characterId,key:e?.dsn}),s=!!c,i=t.useRef(!1);return t.useEffect(()=>{s&&!i.current&&(e?.setup(),i.current=!0),!s&&i.current&&(e?.close(),i.current=!1);},[s]),t.createElement(t.Fragment,null)}function D(){let{connectors:e}=useConnect();return t.useMemo(()=>e.find(n=>!!n.options.appName)?.options.appName??"Current app",[e])}var V=g(t.lazy(()=>import('./lazy-7Y6A4DYS.mjs')));

export { g as a, G as b, J as c, V as d };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-SJNWYHJG.mjs.map